// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CreateSocialItem-cls1___6108c952ad17fa9da94{/*!*/}.CreateSocialItem-cls2___ccb7874ebbaa707859b{font:400 16px/20px Roboto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "CreateSocialItem-cls1___6108c952ad17fa9da94",
	"cls2": "CreateSocialItem-cls2___ccb7874ebbaa707859b CreateSocialItem-cls1___6108c952ad17fa9da94"
};
export default ___CSS_LOADER_EXPORT___;
